import React, { FunctionComponent, ReactNode } from 'react'
import { DriversLicence, Medicare, Passport } from '../'
import { IdentityDocument, DocumentProps } from '../../../model'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'

interface Props extends DocumentProps {
  documentType?: IdentityDocument
}

export const VerifyDocument: FunctionComponent<Props> = ({ documentType, onSuccess, onFailure }) => {
  const renderDocuments = (): ReactNode => {
    switch (documentType) {
      case 'licence':
        return <DriversLicence onSuccess={onSuccess} onFailure={onFailure} />
      case 'passport':
        return <Passport onSuccess={onSuccess} onFailure={onFailure} />
      case 'medicare':
        return <Medicare onSuccess={onSuccess} onFailure={onFailure} />
      default:
        return <DriversLicence onSuccess={onSuccess} onFailure={onFailure} />
    }
  }

  return <MaskedElement>{renderDocuments()}</MaskedElement>
}
